import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronDown, ChevronUp } from "../components/Icons";

const faqsData = [
  {
    title: "Sobre nuestra suscripción",
    faqs: [
      {
        question:
          "¿Quiénes pueden solicitar un técnico especializado a Soluciones Hogar?",
        answer:
          "Todo miembro del hogar registrado puede solicitar en cualquier momento un técnico especializado para asistir dentro del domicilio asociado.",
      },
      {
        question: "¿Qué incluye mi suscripción a Soluciones Hogar?",
        answer:
          "Toda asistencia técnica domiciliaria que puedas necesitar y acceso a nuestros contactos útiles. Podés ver todos los servicios que ofrecemos en nuestra pagina servicios",
      },
      {
        question: "¿Mi familia puede usar mi suscripción?",
        answer:
          "Sí, tu grupo familiar conviviente puede beneficiarse del servicio, siempre que sea del domicilio registrado.",
      },
      {
        question: "¿Cuál es la zona de cobertura de Soluciones Hogar?",
        answer:
          "Actualmente brindamos servicio en CABA, Argentina. Estamos trabajando para expandir nuestra cobertura.",
      },
      {
        question: "¿Cómo pago por mi suscripción a Soluciones Hogar?",
        answer:
          "Podés pagar tu suscripción de forma sencilla con débito automático a través de una tarjeta de crédito. Se paga una vez cada seis meses y se renueva de forma automática.",
      },
      {
        question: "Si me quiero dar de baja, ¿cómo hago?",
        answer:
          "Si querés cancelar tu suscripción, podés hacerlo llamando a nuestro centro de atención. Por tu seguridad, siempre te daremos un número de pedido para confirmar la baja.",
      },
      {
        question: "¿Cómo renuevo mi suscripción?",
        answer:
          "La renovación es automática para que no tengas que preocuparte por nada. Si necesitás actualizar tu método de pago o realizar cambios, podés contactarnos.",
      },
      {
        question: "¿Cuánto cuesta la suscripción a Soluciones Hogar?",
        answer:
          "Nuestra suscripción tiene un costo fijo muy accesible que te permite acceder a todos nuestros beneficios. Consultanos.",
      },
      {
        question:
          "¿Hay un límite de servicios que puedo solicitar con mi suscripción?",
        answer:
          "No, podés solicitar asistencia todas las veces que la necesites.",
      },
    ],
  },
  {
    title: "Sobre los servicios solicitados",
    faqs: [
      {
        question: "¿Cómo solicitar un técnico ?",
        answer:
          "Nuestro horario de atención es de lunes a viernes de 8 a 20 h. Sábados de 8 a 13 y emergencias las 24 h para asociados. Comunicate al 5254-2124 o al whatsapp",
      },
      {
        question: "¿A quién debo pagar el trabajo?",
        answer:
          "El pago del arreglo o service se realiza directamente al técnico independiente una vez finalizado el trabajo. El costo y la forma de pago se acuerdan previamente con él, quien también te facturará por dicho trabajo y te dará un conforme de obra donde consta el trabajo realizado y garantía del mismo.",
      },
      {
        question:
          "¿Puedo solicitar un nuevo trabajo cuando el técnico está en mi casa?",
        answer:
          "Si te surge un nuevo trabajo para agregarle al técnico, te pedimos por favor que nos avises, de esta manera podemos cubrir la doble garantía y asegurarte que tengas el técnico recomendado para cada especialidad.",
      },
      {
        question:
          "¿Qué pasa si el técnico no se presenta o el trabajo no es satisfactorio?",
        answer:
          "Si tenés algún inconveniente con el técnico o servicio, te agradecemos que nos lo comuniques inmediatamente. Contamos con un departamento técnico que evaluará la situación, para que recibas el mejor servicio y de ser necesario, hagas uso de la doble garantía.",
      },
    ],
  },
  {
    title: "Sobre los técnicos independientes",
    faqs: [
      {
        question:
          "¿Cómo reconozco a un técnico recomendado por Soluciones Hogar?",
        answer:
          "Cada trabajo solicitado posee un número de pedido, que solo conocen el técnico, Soluciones Hogar y el asociado. Podés solicitarlo en cualquier momento desde que hacés el pedido.",
      },
      {
        question:
          "¿Los trabajos hechos por técnicos recomendados por Soluciones Hogar son más caros?",
        answer:
          "Nuestros técnicos ofrecen precios justos y acordes al mercado, con la ventaja adicional de contar con nuestro seguimiento para garantizarlo. Y como son técnicos independientes podemos ser totalmente objetivos al evaluarlo en cada trabajo realizado.",
      },
      {
        question:
          "¿Puedo solicitar la visita de varios técnicos y sus presupuestos por un mismo trabajo?",
        answer:
          "No, nuestro equipo de asesores se encarga personalmente de buscar al técnico independiente más idóneo para cada trabajo, quienes mantienen precios justos y acordes al mercado. Para evitar demoras y simplificar la resolución de cada inconveniente, asignamos a un sólo técnico por trabajo. En caso de contar con alguna duda o disconformidad te agradecemos comunicarte con nosotros para re evaluarlo con nuestro departamento técnico quienes en caso que se necesite, enviará un supervisor.",
      },
      {
        question: "¿Cómo selecciona a sus técnicos recomendados?",
        answer:
          "Realizamos un riguroso proceso de entrevistas y seguimiento de cada trabajo para garantizar la objetividad de nuestras recomendaciones. Verificamos la calidad técnica en las tareas realizadas en nuestros asociados en forma permanente. Solo trabajamos con técnicos independientes que cumplen con nuestros estándares de honestidad, confianza y eficiencia.",
      },
    ],
  },
  {
    title: "Sobre la doble garantía técnica",
    faqs: [
      {
        question: "¿Existe alguna garantía por los trabajos hechos?",
        answer:
          "Sí, todos los servicios domiciliarios realizados por nuestros técnicos recomendados cuentan con doble garantía:\n1️ Garantía del técnico sobre el arreglo o servicio brindado.\n2️ Garantía Soluciones Hogar, donde nos aseguramos que ante cualquier inconveniente responda el técnico asignado o nos encargamos de buscar otro especialista para solucionarlo.",
      },
      {
        question: "¿Qué cubre la doble garantía y por cuánto tiempo?",
        answer:
          "Nuestra doble garantía te asegura que, si el trabajo no queda bien hecho, coordinamos la solución con el mismo técnico para que resuelva el inconveniente. Si el inconveniente persiste, un supervisor estará viendo el trabajo para encontrar la manera de solucionarlo. Todo trabajo domiciliario que se realice, cuenta con un conforme de obra que detalla el arreglo, siendo esto lo que se cubre en la garantía.",
      },
    ],
  },
  {
    title: "Urgencias",
    faqs: [
      {
        question:
          "¿Todos los servicios pueden ser solicitados como urgencias las 24hs, los 7 días de la semana?",
        answer:
          "Fuera del horario de atención, contamos con emergencias de los siguientes rubros: Plomeria: en caso de roturas de caño, con fugas de agua que no pueda solucionarse cerrando la llave de paso y Destapación de cañerías. Gasistas: para fugas de gas que no puedan solucionarse cerrando la llave de paso. Cerrajería: puerta trabada impidiendo el ingreso o egreso del hogar, no teniendo otra puerta de acceso. Electricidad: un corte total de luz que no sea producto de un corte general de la compañía eléctrica.",
      },
    ],
  },
];

function PreguntasFrecuentes() {
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <div className="container mx-auto px-4 py-12 md:my-20 lg:my-24 flex flex-col justify-center items-center mt-16">
      <h1 className="pb-10 md:pb-20 text-center w-auto">Preguntas Frecuentes</h1>
      <div className="w-full lg:px-20 flex flex-col gap-8">
        {faqsData.map((section, sectionIndex) => (
          <div key={sectionIndex}>
            <h2 className="pb-2 mb-4">{section.title}</h2>
            <div className="flex flex-col gap-2 md:gap-4 pb-4 md:pb-8">
              {section.faqs.map((faq, faqIndex) => {
                const globalIndex = `${sectionIndex}-${faqIndex}`;
                return (
                  <FAQItem
                    key={globalIndex}
                    question={faq.question}
                    answer={faq.answer}
                    isOpen={openIndex === globalIndex}
                    onClick={() =>
                      setOpenIndex(
                        openIndex === globalIndex ? null : globalIndex
                      )
                    }
                  />
                );
              })}
            </div>
          </div>
        ))}
      </div>
      
      <span className="text-base md:text-lg text-gray-700 mt-20">¿Tienes más dudas? Comunícate con nosotros por nuestros canales de contacto</span>
    </div>
  );
}

const FAQItem = ({ question, answer, isOpen, onClick }) => {
  return (
    <div className={`border-b p-2 md:p-4 transition-shadow duration-300 ${
        isOpen ? "bg-gray-50 border-gray-300 shadow-m rounded-lg" : "bg-white"
      }`}
      >
      <button
        className="flex justify-between items-center w-full text-left"
        onClick={onClick}
      >
        <h3 className="text-base md:text-lg font-bold text-gray-900">{question}</h3>
        {isOpen ? (
          <ChevronUp className="w-5 h-5" />
        ) : (
          <ChevronDown className="w-5 h-5" />
        )}
      </button>
      <AnimatePresence initial={false}>
        {isOpen && (
          <motion.div
            initial={{ height: 0, opacity: 0.5 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0.5 }}
            transition={{ duration: 0.2, ease: "easeInOut" }}
          >
            <p className="text-sm md:text-base mt-2 text-gray-700">{answer}</p>
          </motion.div>
        )}
      </AnimatePresence>{" "}
    </div>
  );
};

export default PreguntasFrecuentes;
